// DEPENDENCIES ---------------------------------------------------------------- //

import { ReportingConfig, ReportingModuleGroup, ReportingTab } from '../types';

// HELPERS ---------------------------------------------------------------- //

/**
 * Whether a reporting tab is visible. Undefined config or absent flag means
 * visible (opt-out default); only an explicit `false` hides it.
 */
export const isTabVisible = (reporting: ReportingConfig | undefined, tab: ReportingTab): boolean =>
  reporting?.tabs?.[tab]?.enabled !== false;

/**
 * Whether an individual module (metric, chart, or KPI) is visible. Undefined
 * config or absent flag means visible (opt-out default); only an explicit
 * `false` hides the module.
 */
export const isModuleVisible = (
  reporting: ReportingConfig | undefined,
  tab: ReportingTab,
  group: ReportingModuleGroup,
  moduleKey: string
): boolean => {
  const groupFlags = reporting?.tabs?.[tab]?.[group];
  return groupFlags?.[moduleKey] !== false;
};
